<template>
<div>
  <v-row>
      <v-col cols="1"></v-col>
      <v-col cols="10">
          <v-autocomplete v-model="key" :items="keys" clearable :loading="loading" :search-input.sync="search" hide-no-data no-filter @click:clear="keys = []" item-text="oem" :item-value="item => item" @input="input" label="OEM/FCC/IC/iSKU" solo return-object>
              <v-list-tile name="ava1" class="pa-2" slot="item" slot-scope="{item}">
                  <v-avatar left>
                      <v-img v-bind:src="item.image"></v-img>
                  </v-avatar>
                  {{item.oem}} - {{item.fcc}} - {{item.ic}}
              </v-list-tile>
          </v-autocomplete>
      </v-col>
      <v-col cols="1">

      </v-col>
  </v-row>
  <v-row v-if="key != null">
      <v-col cols="1"></v-col>
      <v-col cols="8">
          <v-card>
              <v-card-title style="height:50px;margin-top:-3% !important;">
                  Adjust Inventory:
                  <div style="margin-left:10px">
                      <v-chip outlined color="primary">{{key.oem}}</v-chip> -
                      <v-chip outlined color="primary">{{key.fcc}}</v-chip> -
                      <v-chip outlined color="primary">{{key.ic}}</v-chip>
                  </div>
              </v-card-title>
              <v-divider></v-divider>
              <v-form v-if="locations.length > 0">
                <v-row v-for="(loc,index) in locations" style="height:50px">
                  <v-col cols="1"></v-col>
                  <v-col cols="4">
                    <v-text-field v-model="values[index]" @input="inputChange(index)" dense type="number" :label="loc.name" required outlined></v-text-field>
                  </v-col>
                </v-row>
                <v-row style="height:60px">
                  <v-col cols="1"></v-col>
                  <v-col cols="8">
                    <v-text-field v-model="request.notes" dense type="text" label="Notes:" required outlined></v-text-field>
                  </v-col>
                </v-row>
                <v-row style>
                    <v-col cols="4"></v-col>
                    <v-col cols="2">
                        <v-btn color="success" @click="adjustItem" >
                            Adjust Inventory
                        </v-btn>
                    </v-col>
                    <v-col cols="1"></v-col>
                </v-row>
              </v-form>
          </v-card>
      </v-col>
      <v-col cols="1"></v-col>
  </v-row>
</div>
</template>
<script>
export default {
  created() {
    this.locations = this.$store.state.token.locations;
  },
  data: () => ({
    locations: [],
    keys: [],
    key: null,
    item: null,
    values: [],
    search: '',
    loading: false,
    request: {
      locations: [],
      oem: '',
      notes:'',
    },
  }),
  watch: {
      search(val) {
          if (this.loading) return;
          if (val == '' || val == null) return;
          this.loading = true;
          this.$api.searchKey(val).then((response) => {
              if (response.status == 200)
                  this.keys = response.data;
              this.loading = false;
          }).then(error => {
              this.loading = false;
          })
      }
  },
  methods: {
    input(val) {
      if (val != null) {
        this.request.oem = this.key.oem;
        this.values = [];
        this.$api.searchItem(this.request).then((response) => {
          if (response.status = 200) {
            this.item = response.data;
            for (let i = 0; i < this.locations.length; i++) {
              this.values[i] = this.getLocationStock(this.locations[i].id);
            }
          }
        }).catch(error => {

        })
      }
    },
    inputChange(index) {
      let location = this.locations[index];
      let x = -1;
      for (let i = 0; i < this.request.locations.length; i++) {
        if (this.request.locations[i].location.id == location.id) {
          x = i;
          break;
        }
      }
      if (x == -1) {
        this.request.locations.push({
          'location': location,
          'amount': this.values[index]
        });
      } else {
        this.request.locations[x].amount = this.values[index];
      }
    },
    getLocationStock(id){
    let x = -1;
    for (let i = 0; i < this.item.locations.length; i++)
      if (this.item.locations[i].location.id == id) {
        x = i;
        break;
      }

    if (x == -1)
      return 0;
    else
      return this.item.locations[x].amount;


  },
  adjustItem() {
    this.$overlay.show(this);
    this.$api.adjustItem(this.request).then((res) => {
      if (res.status == 200) {
        this.request = {
          locations: [],
          oem: '',
          notes: '',
        };
        this.item = null;
        this.values = [];
        this.keys = [];
        this.key = null;
        this.$toasted.success("Inventory updated").goAway(1200);
      }
      this.$overlay.hide();
    }).catch(error => {
      this.$toasted.error("Error updating inventory").goAway(1200);
      this.$overlay.hide();
    })
  }

}
}
</script>
